// packages block
import { Box, FormControl, FormHelperText, InputLabel } from '@mui/material';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// styles, constants, utils and interfaces block
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { CustomControlProps } from '../../../../shared/lib/interfaceTypes';
import palette from '../../../../shared/lib/theme/palette';
import { CustomPhoneContainer2 } from '../../../../shared/lib/theme/styleComponents';
import { PinInputStyle } from '../../../../shared/lib/theme/styleConstants';

/**
 * It takes multiple params to show a customized input field which can have multiple types.
 *
 * @param {string} controllerName - used for adding ID and name
 * @param {string} controllerLabel - used for adding label on textfield
 * @param {string} error - used for showing errors if the field is not validated
 * @returns JSX Element
 */
export const CustomPhoneController: FC<CustomControlProps> = ({ controllerName, controllerLabel, isDisabled }): JSX.Element => {
  const { control } = useFormContext();
  const { bodyBackground } = palette;
  const countries = import.meta.env.VITE_US_PHONE_NUMBERS_ONLY === 'false' ? ['us', 'pk'] : ['us'];

  return (
    <CustomPhoneContainer2>
      <Controller
        name={controllerName}
        control={control}
        render={({ field: { value, onChange }, fieldState: { invalid, error: { message } = {} } }) => (
          <FormControl variant="outlined" fullWidth error={invalid}>
            <InputLabel shrink={true} id={`phone-${controllerName}`} sx={{ backgroundColor: `${bodyBackground} !important` }}>
              {controllerLabel}
            </InputLabel>

            <Box position="relative" sx={{ opacity: isDisabled ? 0.5 : 1 }}>
              <PhoneInput
                country="us"
                onlyCountries={countries}
                value={value}
                onChange={(phone) => onChange(phone)}
                placeholder=""
                inputClass={'appearance'}
                inputStyle={PinInputStyle}
                disableDropdown={import.meta.env.VITE_US_PHONE_NUMBERS_ONLY === 'true'}
                localization={{ us: 'USA', pk: 'PK' }}
                disabled={isDisabled}
              />
            </Box>

            {invalid && message && <FormHelperText color="error">{message}</FormHelperText>}
          </FormControl>
        )}
      />
    </CustomPhoneContainer2>
  );
};
